document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('faq-search-input');
  const clearBtn = document.getElementById('faq-clear-btn');
  const sidebarLinks = document.querySelectorAll('#faq-scrollspy-navs a');
  const categories = document.querySelectorAll('[data-individual-section]');
  
  if (searchInput) {
    searchInput.addEventListener('input', handleSearch);
    if (clearBtn) {
      clearBtn.addEventListener('click', clearSearch);
    }
  }
  
  function handleSearch(e) {
    const searchTerm = e.target.value.toLowerCase().trim();
    const noResultsElement = document.getElementById('faq-no-results');
    const stickyTopWrapper = document.querySelector('.sticky-top-wrapper');
    
    if (clearBtn) {
      clearBtn.style.display = searchTerm ? 'block' : 'none';
    }
    
    if (!searchTerm) {
      clearSearch();
      return;
    }
    
    let hasAnyVisibleItems = false;
    
    categories.forEach(category => {
      let hasVisibleItems = false;
      const categoryFaqs = category.querySelectorAll('.accordion__container');
      
      categoryFaqs.forEach(faq => {
        const question = faq.querySelector('.accordion__toggle h3').textContent.toLowerCase();
        const answer = faq.querySelector('.accordion__block').textContent.toLowerCase();
        
        if (question.includes(searchTerm) || answer.includes(searchTerm)) {
          faq.classList.remove('hidden');
          hasVisibleItems = true;
          hasAnyVisibleItems = true;
          highlightText(faq, searchTerm);
        } else {
          faq.classList.add('hidden');
        }
      });
      
      // Hide/show the entire category section based on visible items
      if (hasVisibleItems) {
        category.classList.remove('hidden');
      } else {
        category.classList.add('hidden');
      }
      
      const categoryLink = document.querySelector(`#faq-scrollspy-navs a[href="#${category.id}"]`);
      if (categoryLink) {
        const categoryItem = categoryLink.closest('.faq-listing');
        if (hasVisibleItems) {
          categoryItem.classList.remove('greyed-out');
        } else {
          categoryItem.classList.add('greyed-out');
        }
      }
    });
    
    // Show/hide no results message and sidebar wrapper
    if (noResultsElement) {
      noResultsElement.style.display = hasAnyVisibleItems ? 'none' : 'block';
    }
    
    if (stickyTopWrapper) {
      stickyTopWrapper.style.display = hasAnyVisibleItems ? 'block' : 'none';
    }
  }
  
  function clearSearch() {
    if (searchInput) searchInput.value = '';
    if (clearBtn) clearBtn.style.display = 'none';
    
    const noResultsElement = document.getElementById('faq-no-results');
    if (noResultsElement) {
      noResultsElement.style.display = 'none';
    }
    
    const stickyTopWrapper = document.querySelector('.sticky-top-wrapper');
    if (stickyTopWrapper) {
      stickyTopWrapper.style.display = 'block';
    }
    
    const allFaqs = document.querySelectorAll('.accordion__container');
    allFaqs.forEach(faq => {
      faq.classList.remove('hidden');
      removeHighlight(faq);
    });
    
    // Show all category sections
    categories.forEach(category => {
      category.classList.remove('hidden');
    });
    
    document.querySelectorAll('.faq-listing').forEach(item => {
      item.classList.remove('greyed-out');
    });
  }
  
  function highlightText(element, searchTerm) {
    const question = element.querySelector('.accordion__toggle h3');
    const answer = element.querySelector('.accordion__block > div');
    
    [question, answer].forEach(el => {
      if (el.dataset.originalText === undefined) {
        el.dataset.originalText = el.textContent;
      }
      
      const regex = new RegExp(`(${searchTerm})`, 'gi');
      el.innerHTML = el.dataset.originalText.replace(regex, '<mark>$1</mark>');
    });
  }
  
  function removeHighlight(element) {
    const question = element.querySelector('.accordion__toggle h3');
    const answer = element.querySelector('.accordion__block > div');
    
    [question, answer].forEach(el => {
      if (el.dataset.originalText) {
        el.textContent = el.dataset.originalText;
      }
    });
  }
  
  const faqParent = document.querySelector('[data-faqsparent]');
  const faqSections = faqParent
    ? faqParent.querySelectorAll('[data-individual-section]')
    : document.querySelectorAll('[data-individual-section]');
  let isClickScrolling = false;

  function updateStickyBorder() {
    const stickyNav = document.querySelector('.faq-container .sticky-top-wrapper');
    if (!stickyNav) return;

    if (window.innerWidth >= 992) {
      stickyNav.classList.remove('is-stuck');
      return;
    }

    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-header-height'), 10) || 0;
    const loyaltyHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-loyaltywidget-height'), 10) || 0;
    const stickyTop = headerHeight + loyaltyHeight;
    const top = stickyNav.getBoundingClientRect().top;
    const isStuck = top <= stickyTop + 2 && top >= stickyTop - 2;

    stickyNav.classList.toggle('is-stuck', isStuck);
  }

  function getScrollOffset() {
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-header-height'), 10) || 0;
    const loyaltyHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--bs-loyaltywidget-height'), 10) || 0;
    const stickyNav = document.querySelector('.sticky-top-wrapper');
    const stickyNavHeight = stickyNav && window.innerWidth < 992 ? stickyNav.offsetHeight : 0;
    return headerHeight + loyaltyHeight + stickyNavHeight + 16;
  }

  function setActiveNav(id) {
    if (!id) return;
    sidebarLinks.forEach(link => {
      const linkId = link.getAttribute('data-id') || (link.getAttribute('href') || '').replace('#', '');
      link.classList.toggle('active', linkId === id);
    });

    const activeLink = document.querySelector('#faq-scrollspy-navs a.active');
    if (activeLink && activeLink.scrollIntoView) {
      activeLink.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  function updateActiveFromScroll() {
    if (isClickScrolling || !faqSections.length) return;

    const offset = getScrollOffset();
    let currentSection = null;

    faqSections.forEach(section => {
      if (section.classList.contains('hidden')) return;
      if (section.getBoundingClientRect().top - offset <= 15) {
        currentSection = section;
      }
    });

    if (!currentSection) {
      currentSection = Array.from(faqSections).find(section => !section.classList.contains('hidden'));
    }

    if (currentSection) setActiveNav(currentSection.id);
  }

  sidebarLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href').substring(1);
      const targetSection = document.getElementById(targetId);

      if (targetSection) {
        setActiveNav(targetId);
        isClickScrolling = true;

        const offset = getScrollOffset();
        const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
          top: Math.max(targetPosition, 0),
          behavior: 'smooth'
        });

        window.setTimeout(() => {
          isClickScrolling = false;
          updateActiveFromScroll();
        }, 800);
      }
    });
  });

  window.addEventListener('scroll', function() {
    updateStickyBorder();
    updateActiveFromScroll();
  }, { passive: true });
  window.addEventListener('resize', function() {
    updateStickyBorder();
    updateActiveFromScroll();
  });
  updateStickyBorder();
  updateActiveFromScroll();
});
